import React from 'react'
import Navbar from './Navbar'
import HeroSection from './HeroSection'
import AboutSection from './AboutSection'
import KeyHighlights from './Keyhighlights'
import Researchtracks from './Researchtracks'
import DatesAndRegistration from './Datesandregistration'
import SDGSection from './Sdgsection'
import VenueSection from './Venuesection'
import Footer from './Footer'



function HomeIndex() {
  return (
    <div style={{ fontFamily: "Poppins, sans-serif" }}>
      <Navbar />
      <HeroSection />
      <AboutSection />
      <KeyHighlights />
        <Researchtracks />
        <DatesAndRegistration />
        <SDGSection />
        <VenueSection />
        <Footer />
    </div>
  )
}

export default HomeIndex
